import { render, staticRenderFns } from "./UnavailableExaminer.vue?vue&type=template&id=4ed1573c&scoped=true"
import script from "./UnavailableExaminer.vue?vue&type=script&lang=js"
export * from "./UnavailableExaminer.vue?vue&type=script&lang=js"
import style0 from "./UnavailableExaminer.vue?vue&type=style&index=0&id=4ed1573c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed1573c",
  null
  
)

export default component.exports